export function formatMembershipDetail(membership) {
  if (!membership) {
    return { title: "Нет абонемента", meta: "Выдайте абонемент в карточке клиента" };
  }
  const title = membership.plan_name || "Абонемент";
  const parts = [];
  if (membership.plan_type === "visits" && membership.visits_remaining != null) {
    parts.push(`${membership.visits_remaining} зан. осталось`);
  }
  if (membership.ends_at) {
    parts.push(`до ${formatDateShort(membership.ends_at)}`);
  } else if (membership.plan_type !== "visits") {
    parts.push("без срока");
  }
  if (membership.status === "pending") {
    parts.push("ожидает оплаты");
  } else if (membership.status && membership.status !== "active") {
    parts.push(membershipStatusLabel(membership.status));
  }
  return { title, meta: parts.join(" · ") || "Активен" };
}

export function membershipStatusLabel(status, notes) {
  if (
    status === "cancelled" &&
    notes &&
    (/Продление:\s*\+/i.test(notes) ||
      /Пополнение применено/i.test(notes) ||
      /зачислен/i.test(notes))
  ) {
    return "Зачислен";
  }
  const map = {
    pending: "Ожидает оплаты",
    active: "Активен",
    expired: "Истёк",
    frozen: "Заморожен",
    cancelled: "Отменён",
  };
  return map[status] || status;
}

export function membershipStatusTone(status, notes) {
  if (
    status === "cancelled" &&
    notes &&
    (/Продление:\s*\+/i.test(notes) || /Пополнение применено/i.test(notes))
  ) {
    return "success";
  }
  if (status === "active") return "ok";
  if (status === "pending") return "warn";
  if (status === "frozen") return "warn";
  return "muted";
}

export function paymentMethodLabel(method) {
  const map = {
    cash: "Наличные",
    card_transfer: "Перевод",
    online: "Онлайн",
    other: "Другое",
  };
  return map[method] || method || "—";
}

export function formatAttendanceSummary(att) {
  if (!att || !att.total) {
    return { label: "—", hint: "Нет занятий в этом месяце", pct: null };
  }
  const pct =
    att.pct != null
      ? att.pct
      : Math.round((Number(att.present || 0) / att.total) * 100);
  return {
    label: `${att.present} из ${att.total}`,
    hint: `${pct}% посещаемость`,
    pct,
  };
}

export const COMPETITION_STATUS_LABELS = {
  pending: "На рассмотрении",
  approved: "Допущен",
  rejected: "Отклонён",
  cancelled: "Отмена",
};

export function competitionResultLabel(reg) {
  if (reg?.placement) {
    const n = Number(reg.placement);
    if (n === 1) return "1 место";
    if (n === 2) return "2 место";
    if (n === 3) return "3 место";
    return `${n} место`;
  }
  if (reg?.result_status === "participated") return "Участвовал";
  if (reg?.result_status === "no_show") return "Не явился";
  return null;
}

export function pollAnswerLabel(row) {
  const id = row?.option_id || row?.answers?.option_id;
  if (id === "coming" || id === "yes") return "Придёт";
  if (id === "not_coming" || id === "no") return "Не придёт";
  if (id === "maybe") return "Под вопросом";
  return id ? String(id) : "Ответил";
}

export function pollAnswerTone(row) {
  const id = row?.option_id || row?.answers?.option_id;
  if (id === "coming" || id === "yes") return "ok";
  if (id === "not_coming" || id === "no") return "muted";
  if (id === "maybe") return "warn";
  return "default";
}

export function formatDateShort(isoDate) {
  if (!isoDate) return "";
  const [y, m, d] = String(isoDate).slice(0, 10).split("-");
  return `${d}.${m}.${y}`;
}

/** Одна строка под именем в карточке клиента */
export function clientProfileSubtitle(sport) {
  if (!sport) return "Без группы";
  const parts = [];
  const childCount = sport.children?.length || 0;
  if (sport.also_guardian || sport.account_kind === "guardian") {
    if (childCount) {
      parts.push(
        childCount === 1 ? "1 ребёнок" : `${childCount} ${childCount < 5 ? "ребёнка" : "детей"}`,
      );
    } else if (sport.account_kind === "guardian") {
      return "Родитель";
    }
  }
  if (sport.groups?.length) parts.push(sport.groups[0]);
  const m = sport.membership;
  if (m?.status === "pending") {
    parts.push("абонемент не оплачен");
  } else if (m?.plan_name) {
    parts.push(m.plan_name);
    if (m.visits_remaining != null) {
      parts.push(`${m.visits_remaining} зан.`);
    }
  }
  return parts.length ? parts.join(" · ") : "Без группы";
}

export function clientStatusBadges(sport) {
  const badges = [];
  if (!sport) return badges;
  if (sport.registration_status === "pending") {
    badges.push({ tone: "warn", label: "На модерации" });
  }
  if (sport.is_archived) badges.push({ tone: "muted", label: "Архив" });
  if (
    sport.warnings?.includes("unpaid_membership") ||
    (sport.membership?.status === "pending")
  ) {
    badges.push({ tone: "warn", label: "Должник" });
  } else if (sport.warnings?.includes("debtor")) {
    badges.push({ tone: "danger", label: "Нет абонемента" });
  } else if (sport.warnings?.includes("membership_expiring")) {
    badges.push({ tone: "warn", label: "Заканчивается" });
  }
  return badges;
}
